import { render, staticRenderFns } from "./MeasuresDetailView.vue?vue&type=template&id=d10705b4"
import script from "./MeasuresDetailView.vue?vue&type=script&lang=ts"
export * from "./MeasuresDetailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports